<template>
  <div>
    <div class="detail-kelas">
      <v-toolbar flat>
        <div class="py-5"><v-icon color="blue">mdi-format-list-bulleted</v-icon></div>
        <base-breadcrumbs class="px-4" :items="breadcrumbs" />
      </v-toolbar>
    </div>

    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-list>
              <v-list-item>
                <v-list-item-avatar color="success" size="50">
                  <v-icon dark>mdi-google-classroom</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-row>
                    <v-col cols="12" lg="5">
                      <div class="caption grey--text">Nama Kelas</div>
                      <div class="body-1 black--text">
                        <strong> {{ $getDeepObj(kelas, 'nama') || '-' }} </strong>
                      </div>
                    </v-col>
                    <v-col cols="12" lg="4" v-if="kelas.lokasi">
                      <div class="caption grey--text">Lokasi</div>
                      <div class="body-1 black--text">
                        <div>{{ kelas.lokasi }}</div>
                        <div class="body-2">
                          {{ $getDeepObj(kelas, 'm_kota.keterangan') }}
                          <span v-if="kelas.k_propinsi">- {{ $getDeepObj(kelas, 'm_propinsi.keterangan') }}</span>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" lg="4" v-if="kelas.tgl_mulai || kelas.tgl_selesai">
                      <div class="caption grey--text">Jadwal</div>
                      <div class="body-1 black--text">
                        <div v-if="kelas.tgl_mulai && kelas.tgl_selesai">
                          {{ $durasi(kelas.tgl_mulai, kelas.tgl_selesai) }}
                        </div>
                        <div v-else>
                          {{ $localDate(kelas.tgl_mulai || kelas.tgl_selesai) }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card flat>
      <v-card-title class="pa-0">
        <base-table-header
          outlined-button
          @download="onDownloadList"
          @filter="onFilter"
          @search="onSearch"
          @reload="onReload"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text"> Daftar Peserta </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0">
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list>
                <v-list-item class="px-0">
                  <v-list-item-avatar color="secondary">
                    <v-icon dark>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-label color="caption">
                          <small>Peserta</small>
                        </v-label>
                        <div class="text-body-1 font-weight-medium">{{ $getDeepObj(item, 'ptk.nama') }}</div>
                        <div class="text-body-2">
                          SIMPKB ID: <span class="font-weight-medium">{{ $getDeepObj(item, 'ptk_id') }}</span>
                        </div>
                        <div class="text-body-2">
                          Asal Sekolah: <span class="font-weight-medium">{{ $getDeepObj(item, 'sekolah.nama') }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-label color="caption">
                          <small>Penilai</small>
                        </v-label>
                        <div v-if="$getDeepObj(item, 'psp_pelatihan_kelas_nilais.0.akun')">
                          <div class="text-body-1 font-weight-medium">
                            {{ $getDeepObj(item, 'psp_pelatihan_kelas_nilais.0.akun.nama') }}
                          </div>
                          <div class="text-body-2">
                            Akun SIMPKB:
                            <span class="font-weight-medium">
                              {{ $getDeepObj(item, 'psp_pelatihan_kelas_nilais.0.akun.email') }}
                            </span>
                          </div>
                        </div>
                        <div v-else>-</div>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-label color="caption">
                          <small>Status</small>
                        </v-label>
                        <div class="mt-1">
                          <v-chip
                            :color="$getDeepObj(item, 'psp_pelatihan_kelas_nilais.0') ? 'success' : 'grey'"
                            class="white--text"
                          >
                            {{ $getDeepObj(item, 'psp_pelatihan_kelas_nilais.0') ? 'Sudah Dinilai' : 'Belum Dinilai' }}
                          </v-chip>
                        </div>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-label color="caption">
                          <small>Aksi</small>
                        </v-label>
                        <div class="mt-1">
                          <v-btn
                            color="info"
                            :disabled="
                              !$allow('psp-pelatihan-imbas-nilai.save') &&
                                !$getDeepObj(item, 'psp_pelatihan_kelas_nilais.0')
                            "
                            class="text-capitalize"
                            depressed
                            small
                            @click="onNilai(item)"
                          >
                            {{ $allow('psp-pelatihan-imbas-nilai.save') ? 'Nilai' : 'Lihat Nilai' }}
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full
      ref="modal"
      :title="`${formulir.mode === 'form' ? 'Formulir' : 'Detail'} Penilaian Pengimbasan`"
      :use-save="formulir.mode === 'form'"
      @save="onSave"
    >
      <form-nilai ref="formulir" :rubriks="rubriks" :init-value="formulir.init" :mode="formulir.mode" />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import list from '@mixins/list';
import FormNilai from './form/Nilai.vue';
import BaseBreadcrumbs from '@components/base/BaseBreadcrumbs.vue';
export default {
  name: 'Detail',
  components: { BaseBreadcrumbs, FormNilai },
  mixins: [list],
  data() {
    return {
      kelas: {},
      formulir: {},
      rubriks: [],
    };
  },
  computed: {
    breadcrumbs() {
      const routeName = this.$route.name.split('-');
      return [
        { text: 'Daftar Kelas Pengimbasan', to: [routeName[0], routeName[1]].join('-') },
        { text: 'Daftar Peserta' },
      ];
    },

    kelasId() {
      return this.$getDeepObj(this.$route, 'params.kelas_id') || '';
    },
  },
  async created() {
    await this.getRubrik();
  },
  methods: {
    ...mapActions('pengimbasanNilai', ['rubrik', 'peserta', 'pesertaNilai', 'save']),

    fetchData: function() {
      return new Promise((resolve) => {
        const params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
        this.peserta({ id: this.kelasId, params }).then(({ data, kelas, total, last_page }) => {
          this.data = data || [];
          this.kelas = kelas || {};
          this.total = total || data.length || 0;
          this.pageTotal = last_page || 1;

          resolve(true);
        });
      });
    },

    async getRubrik() {
      const resp = await this.rubrik();
      this.rubriks = resp || [];
    },

    async onNilai(item) {
      const resp = await this.pesertaNilai({ id: item.psp_pelatihan_kelas_peserta_id });

      this.$set(this.formulir, 'mode', this.$allow('psp-pelatihan-imbas-nilai.save') ? 'form' : 'readonly');
      this.$set(this.formulir, 'id', item.psp_pelatihan_kelas_peserta_id);
      this.$refs.modal.open();

      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', resp);
      });
    },

    async onDetail(item) {
      const ajuan = await this.peserta({ id: item.psp_pelatihan_ajuan_id });
      const pesertas = ajuan.psp_pelatihan_kandidats || [];

      this.$set(this.formulir, 'mode', 'detail');
      this.$set(this.formulir, 'id', item.psp_pelatihan_ajuan_id);
      this.$set(this.formulir, 'ajuan', ajuan);
      this.$set(this.formulir, 'pesertas', pesertas);
      this.$refs.modal.open();
    },

    onSave() {
      const values = this.$refs.formulir.getValue();
      let payload = [];
      let isError = false;

      this.rubriks.forEach((item) => {
        if ([undefined, '', null].includes(values[item.k_pelatihan_rubrik_psp])) {
          isError = true;
          return;
        } else {
          const objSave = {
            k_pelatihan_rubrik_psp: item.k_pelatihan_rubrik_psp,
            nilai: values[item.k_pelatihan_rubrik_psp],
          };
          payload.push(objSave);
        }
      });

      if (isError) {
        this.$error('Harap melengkapi instrumen penilaian');
        this.$refs.modal.loading = false;
        return;
      }

      this.save({ id: this.formulir.id, params: { nilai: payload } })
        .then(() => {
          this.$success('Berhasil disimpan');
          this.$refs.modal.dialog = false;
          this.onReload();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
